var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"loading",class:_vm.relative ? '' : 'centered',attrs:{"indeterminate":"","color":_vm.app ? 'green lighten-2' : 'grey',"size":_vm.small ? 50 : 100,"width":_vm.small ? 6 : 10}})}
var staticRenderFns = []

export { render, staticRenderFns }